let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7H3O2")).then(() => parcelRequire('goVIR'));